import React from 'react';
import { Paper, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import Typography from '../i18n/LocalizedTypography';
import { LocalizedTableCell as TableCell } from '../i18n/LocalizedMui';
import { useTranslation } from 'react-i18next';

export default function KpFourStepPanel({ planetRows, planetName }: { planetRows: any[]; planetName: (name: string) => string }) {
  const { t } = useTranslation();
  const keys = ['level1', 'level2', 'level3', 'level4'];
  return <Paper sx={{ p: 2 }}>
    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.5 }}>{t('kp.fourLevelPlanetarySignificatorSystem')}</Typography>
    {['houses', 'planets'].map(view => <React.Fragment key={view}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mt: 2, mb: 1 }}>{t(view === 'houses' ? 'kp.sixFoldHouseView' : 'kp.sixFoldPlanetView')}</Typography>
      <TableContainer><Table size="small" sx={{ tableLayout: view === 'houses' ? 'fixed' : 'auto', minWidth: 750,
        '& tbody tr:nth-of-type(even)': { bgcolor: 'action.hover' },
        '& th:first-of-type, & td:first-of-type': { position: 'sticky', left: 0, zIndex: 1, bgcolor: 'background.paper', width: view === 'houses' ? 64 : undefined, minWidth: view === 'houses' ? 64 : 85, maxWidth: view === 'houses' ? 64 : undefined, px: view === 'houses' ? 1 : 2, boxSizing: 'border-box', overflowWrap: 'anywhere' },
        '& thead th:first-of-type': { zIndex: 2 } }}>
        <TableHead><TableRow sx={{ bgcolor: 'action.selected' }}>
          <TableCell sx={{ fontWeight: 700 }}>{t(view === 'houses' ? 'kp.significatorHouseHeader' : 'kp.significatorPlanetHeader')}</TableCell>
          {keys.map((key, index) => <TableCell key={key} sx={{ fontWeight: 700 }}>{String.fromCharCode(65 + index)}: {t(`kp.${view === 'houses' ? 'fourHouseColumn' : 'fourLevelColumn'}${index + 1}`)}</TableCell>)}
        </TableRow></TableHead>
        <TableBody>{(view === 'houses'
          ? Array.from({ length: 12 }, (_, index) => ({ id: String(index + 1), cells: [String(index + 1),
            ...keys.map(key => planetRows.filter(row => row[key].includes(index + 1)).map(row => planetName(row.planet)).join(', ') || '-')] }))
          : planetRows.map(row => ({ id: row.planet, cells: [planetName(row.planet), ...keys.map(key => row[key].join(', ') || '-')] })))
          .map(row => <TableRow key={row.id}>{row.cells.map((value, index) => <TableCell key={index} sx={{ fontWeight: index === 0 ? 700 : 400 }}>{value}</TableCell>)}</TableRow>)}
        </TableBody>
      </Table></TableContainer>
    </React.Fragment>)}
  </Paper>;
}
